import * as asserts from 'Asserts';
import ProteinActions from 'molbio/proteins/ProteinActions';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

class ProteinInformationPanelView extends BasicInformationPanelView {
  constructor(...args) {
    super(...args);
    this.saveModel = this.saveModel.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this.getDownloadInfo = this.getDownloadInfo.bind(this);
  }

  saveModel(data) {
    ProteinActions.update(this.model.id, data, {success: this.onSaveSuccess});
  }

  deleteModel() {
    ProteinActions.delete(this.model.id, {success: this.onDeleteSuccess});
  }

  getDownloadInfo() {
    const editUrl = this.model.editURL();
    asserts.assertAndContinue(editUrl.slice(-5) === '/edit', 'Expected edit URL to end with /edit.');
    return [
      {
        url: editUrl.replace(/\/edit$/, '.fasta'),
        title: 'FASTA (.fasta)',
      },
      {
        url: editUrl.replace(/\/edit$/, '.gp'),
        title: 'GenPept (.gp)',
      },
    ];
  }
}

export default ProteinInformationPanelView;
